// extracted by mini-css-extract-plugin
export default {"card":"card__1yvHZ","cardHeader":"cardHeader__aBSsR","cardHeaderText":"cardHeaderText__3sDcK"};